import BaseModel from '../base/BaseModel.model';
export default class Language extends BaseModel {

    public key?: string;
    public name?: string; 
    constructor(){
        super();
        this.init();
    }

    init(){
        this.key = "";
        this.name = "";
    }
}